import React, { useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { AutoAwesome as SparkleIcon } from "../icons";
import { functions } from "../firebase";
import { T } from "../routes/Translate";

// "Mejorar con IA" en los formularios de publicar: manda lo que ya cargó el
// usuario (fields) a aiWriteListing (functions/aiAssistant.js, Qwen) y
// devuelve título y descripción nuevos por onResult. No inventa datos: si
// falta información, la descripción sale más corta.
const AiWriteButton = ({ type, fields, maxTitle = 70, maxDescription, onResult }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const hasData = Object.values(fields || {}).some((v) => String(v ?? "").trim());

  const handleClick = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await functions.httpsCallable("aiWriteListing", { timeout: 300000 })({ type, fields });
      const title = String(res.data?.title || "").slice(0, maxTitle);
      let description = String(res.data?.description || "");
      if (maxDescription && description.length > maxDescription) {
        description = `${description.slice(0, maxDescription - 1).replace(/\s+\S*$/, "")}…`;
      }
      onResult({ title, description });
    } catch (err) {
      setError(err?.message || "No se pudo usar la IA.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ my: 1 }}>
      <Button
        variant="outlined"
        size="small"
        onClick={handleClick}
        disabled={loading || !hasData}
        startIcon={loading ? <CircularProgress size={16} /> : <SparkleIcon />}
        sx={{ textTransform: "none", borderRadius: 999 }}
      >
        {loading ? <T>Escribiendo...</T> : <T>Mejorar título y descripción con IA</T>}
      </Button>
      {error && (
        <Typography variant="caption" color="error" sx={{ display: "block", mt: 0.5 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default AiWriteButton;
